module.exports = __webpack_public_path__ + "img/6_26@2x.0e8dc1d0.png";